<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6">
        <v-btn
          text
          :href="`${'https://az1-medias.s3.ap-south-1.amazonaws.com/dj/Sample+Template+Import+26-04-2023+V1.0.xlsx'}`"
          target="_blank"
          >Download sample file</v-btn
        >
        <v-card-title>
          <backbutton></backbutton>
          Upload {{ $route.query.type.toLowerCase() }} data
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="quotation_name"
                outlined
                :label="`${$route.query.type}` + ' ' + 'NAME '"
                prepend-inner-icon="mdi-checkbook"
                :error-messages="errors.quotation_name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="crude_quotations.length == 0">
              <input
                type="file"
                id="file"
                name="file"
                ref="file"
                accept="application/ms-excel"
                multiple
                @input="handleFileUpload"
              />
            </v-col>
            <v-col v-else>
              <v-btn
                color="success"
                :loading="isProcessing"
                :disabled="isProcessing"
                @click="processFile"
              >
                Upload file</v-btn
              >
              <v-btn
                class="ml-5"
                color="error"
                @click="truncatePendingDocuments"
              >
                Delete</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <span style="color: red" v-show="isError">{{ error_msg }} </span>
          </v-row>
        </v-card-text>
      </v-card>
      <br />
      <v-card elevation="6">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">ID</th>
                <th class="text-left">Type</th>
                <th class="text-left">Job Name</th>
                <th class="text-left">Status</th>
                <th class="text-left">Supplier Name</th>
                <th class="text-left">Supplier Email</th>
                <th class="text-left">QTY</th>
                <th class="text-left">Cost</th>
                <th class="text-left">Discount Percentage</th>
                <th class="text-left">Discount Amount</th>
                <th class="text-left">Additional Percentage</th>
                <th class="text-left">Additional Amount</th>
                <th class="text-left">Total Cost</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(crudquotation, at) in crude_quotations"
                :key="`crudquotation${at}`"
              >
                <td>{{ at + 1 }}</td>
                <td>{{ crudquotation.type }}</td>
                <td>{{ crudquotation.job_name }}</td>
                <td>{{ crudquotation.status }}</td>
                <td>{{ crudquotation.supplier_name }}</td>
                <td>{{ crudquotation.supplier_email }}</td>
                <td>{{ crudquotation.qty }}</td>
                <td>{{ crudquotation.cost }}</td>
                <td>{{ crudquotation.discount_amount }}</td>
                <td>{{ crudquotation.discount_percentage }}</td>
                <td>{{ crudquotation.additional_amount }}</td>
                <td>{{ crudquotation.additional_percentage }}</td>
                <td>{{ crudquotation.total_cost }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
      <!-- Upload Success Dialog Box -->
      <v-dialog v-model="is_Uploaded" width="600">
        <v-card>
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-cloud-upload-outline
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>
                        The file has been uploaded successfully. Now you can
                        Preview the List & process accordingly.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Uploaded = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Process Success Dialog Box -->
      <v-dialog v-model="is_Processed" width="600">
        <v-card>
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-progress-download
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>
                        The file has been processed successfully. Now you can
                        see your quotations in Quotation's Tab.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Processed = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Truncate Success Dialog Box -->
      <v-dialog v-model="is_Truncated" width="600">
        <v-card>
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: red; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty-outline
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: red">Deleted!</h1>
                      <br />
                      <h3>
                        The file has been deleted successfully. Now you can
                        select a new file to upload.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Truncated = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import backbutton from "@/components/backbutton.vue";
export default {
  components: { backbutton },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Upload User Excel",
  },
  data() {
    return {
      quotation_name: "",
      crude_quotations: [],
      isLoading: false,
      isUploading: false,
      is_Uploaded: false,
      isProcessing: false,
      is_Processed: false,
      is_Truncated: false,
      isError: false,
      error_msg: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true;
      let crude_quotations = await axios.get(`/crude_quotations`);
      this.crude_quotations = crude_quotations.data.data;
      this.count = crude_quotations.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.quotation_name = "";
      this.isLoading = false;
    },
    async handleFileUpload() {
      this.isUploading = true;
      this.isUploadingError = false;
      this.error_msg = "";
      this.quotations = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append("quotation_name", this.quotation_name);
      formData.append("quotationsData", this.quotations);
      this.changeValue = 100;
      await axios
        .post("upload_quotation", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.data) this.crude_quotations = response.data.data;
          this.is_Uploaded = true;
        })
        .catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        });
    },
    async processFile() {
      try {
        this.isProcessing = true;
        await axios
          .get(
            `process_quotation?quotation_name=${this.quotation_name}&project_type=${this.$route.query.type}`
          )
          .catch(() => {
            this.isError = true;
            this.error_msg =
              "Looks like system faced an error while processing the File. Kindly check the file before processing ...";
          });
        if (this.error_msg == "") {
          await axios.get("truncate_quotations");
          this.crude_quotations = [];
        }
        this.isProcessing = false;
        this.is_Processed = true;
        // alert("Processed Successfully");
      } catch (e) {
        console.log(e);
      }
    },
    async truncatePendingDocuments() {
      await axios.get("truncate_quotations");
      this.is_Truncated = true;
      // alert("Truncated Successfully");
      this.crude_quotations = [];
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
td {
  min-width: 130px !important;
}
</style>
